import { createPortal } from "react-dom";
import { X } from "@phosphor-icons/react";

export default function Modal({ open, onClose, title, children, footer, size = "md", testid }) {
  if (!open) return null;
  const widths = { sm: "max-w-sm", md: "max-w-lg", lg: "max-w-2xl" };
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 sm:p-6 overflow-y-auto">
      <div className="fixed inset-0 bg-[#1A1A1A]/40 backdrop-blur-sm" onClick={onClose} />
      <div data-testid={testid} className={`relative w-full ${widths[size]} bg-white rounded-2xl border border-[#E5E2DC] shadow-xl my-8 fade-up`}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E5E2DC]">
          <h3 className="font-heading text-lg font-semibold tracking-tight">{title}</h3>
          <button onClick={onClose} data-testid="modal-close" className="p-1.5 rounded-lg text-[#6B6A67] hover:bg-[#E8E4DF] transition-colors">
            <X size={18} />
          </button>
        </div>
        <div className="px-6 py-5">{children}</div>
        {footer && <div className="px-6 py-4 border-t border-[#E5E2DC] flex justify-end gap-3">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="label-caps block mb-1.5">{label}</label>
      {children}
    </div>
  );
}

export const inputCls =
  "w-full px-3.5 py-2.5 rounded-lg bg-white border border-[#E5E2DC] outline-none focus:ring-1 focus:ring-[#2C3E35] focus:border-[#2C3E35] transition text-sm";

export function PrimaryBtn({ children, ...props }) {
  return (
    <button {...props} className={`px-4 py-2.5 rounded-lg bg-[#2C3E35] text-white text-sm font-medium hover:bg-[#1E2B25] transition-colors disabled:opacity-60 inline-flex items-center gap-2 ${props.className || ""}`}>
      {children}
    </button>
  );
}

export function GhostBtn({ children, ...props }) {
  return (
    <button {...props} className={`px-4 py-2.5 rounded-lg border border-[#E5E2DC] text-[#3a3a38] text-sm font-medium hover:bg-[#E8E4DF] transition-colors ${props.className || ""}`}>
      {children}
    </button>
  );
}
